import React from 'react';
import styled from 'styled-components';
import { variables } from '../utils';

export interface CardProps {
  className?: string;
  style?: object;
}

const StyledCard = styled.div.attrs<CardProps>({
  className: 'br2 ba b--light-gray'
})`
  a > & {
    border-color: ${variables.lightGray};
  }
`;

export const Card: React.FC<CardProps> = ({ children, className, ...rest }) => {
  return (
    <StyledCard className={className} {...rest}>
      {children}
    </StyledCard>
  );
};

export const CardSegment: React.FunctionComponent<CardProps> = ({
  children,
  className = '',
  ...rest
}) => {
  return (
    <div className={`ph3 ph4-ns ${className}`} {...rest}>
      {children}
    </div>
  );
};
